import { CustomerType, State, StreetType } from '@energy-retailer/constants';
import { type StateCreator } from 'zustand'

import type { PropertySchema } from '@energy-retailer/schema';

type PropertySearch = {
    addressSearch: string;
};

const initialState: PropertySchema & PropertySearch = {
    addressSearch: '',
    address: {
        id: '',
        full: '',
        state: State.VIC,
        suburb: '',
        postcode: '',
        houseNumber: undefined,
        houseSuffix: '',
        streetName: '',
        streetType: StreetType.Street,
        country: '',
    },
    hasSmartMeter: false,
    hasTOUMeter: false,
    supportsEV: false,
    encryptedNmi: '',
    maskedNmi: '',
    customerType: CustomerType.Residential,
    gasDistributors: [],
    electricityDistributors: [],
    isGasAvailable: false,
};

export type PropertySliceActions = {
    setPropertyAddressLookupDetails: (id: string, name: string) => void;
    setPropertyDetails: (details: PropertySchema) => void;
    setCustomerType: (
        customerType: CustomerType.Residential | CustomerType.Business
    ) => void;
    resetProperty: () => void;
};

export type PropertySliceState = {
    property: PropertySchema & PropertySearch;
};

export const PropertySlice: StateCreator<
    PropertySliceActions & PropertySliceState,
    [['zustand/devtools', never]],
    [],
    PropertySliceActions & PropertySliceState
> = (set) => ({
    property: initialState,
    setPropertyDetails: (details: PropertySchema) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set(
            (state: any) => ({ property: { ...state.property, ...details } }),
            undefined,
            'PropertySlice/setPropertyDetails'
        );
    },
    setCustomerType: (
        customerType: CustomerType.Residential | CustomerType.Business
    ) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set(
            (state: any) => ({ property: { ...state.property, customerType } }),
            undefined,
            'PropertySlice/setCustomerType'
        );
    },
    setPropertyAddressLookupDetails: (addressId: string, addressSearch: string) => {
        set(
            (state) => ({
                property: {
                    ...state.property,
                    addressSearch,
                    address: {
                        ...state.property.address,
                        id: addressId,
                    },
                },
            }),
            undefined,
            'PropertySlice/setPropertyAddressLookupDetails'
        );
    },
    resetProperty: () => {
        set(
            { property: initialState },
            undefined,
            'PropertySlice/resetProperty'
        );
    },
});
